import { IconProps } from '../../types/IconProps';

export const Link = ({ variant, className }: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    fill='none'
    className={`${className || ''}`}>
    <g clipPath='url(#a)'>
      <path
        fill={variant === 'light' ? '#fff' : '#0B223E'}
        d='M15.4 8.5a.722.722 0 0 1 0 1.022l-5.778 5.78a.723.723 0 1 1-1.023-1.023l5.78-5.78a.722.722 0 0 1 1.022 0Zm4.51-4.51a5.057 5.057 0 0 0-7.151 0l-2.715 2.714a.723.723 0 1 0 1.022 1.022l2.715-2.709c1.988-1.944 5.335-1.007 6.025 1.686a3.612 3.612 0 0 1-.917 3.421l-2.715 2.715a.723.723 0 0 0 1.021 1.022l2.716-2.719a5.057 5.057 0 0 0 0-7.152Zm-6.976 12.084-2.715 2.715c-1.944 1.988-5.31 1.125-6.06-1.552a3.612 3.612 0 0 1 .953-3.556l2.714-2.714a.723.723 0 0 0-1.023-1.022L4.09 12.659c-2.753 2.753-1.494 7.453 2.267 8.461a5.057 5.057 0 0 0 4.885-1.309l2.714-2.715a.722.722 0 1 0-1.022-1.022Z'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M2 1.9h20v20H2z' />
      </clipPath>
    </defs>
  </svg>
);
